import React from 'react';
import SkillBadge from './SkillBadge';

import python from '../../assets/python.png';
import node from '../../assets/node.png';
import express from '../../assets/express.png';
import react from '../../assets/react.png';
import html from '../../assets/html-5.png';
import css from '../../assets/css.png';

const skillGroups = {
  Backend: [
    { icon: python, label: 'Python' },
    { icon: null, label: 'FastAPI' },
    { icon: null, label: 'Flask' },
    { icon: node, label: 'Node.js' },
    { icon: express, label: 'Express.js' },
    { icon: null, label: 'Spring Boot' },
  ],
  'ML/NLP': [
    // { icon: null, label: 'Transformers' },
    { icon: python, label: 'scikit-learn' },
    { icon: python, label: 'spaCy' },
    { icon: python, label: 'BERT' },
    // { icon: python, label: 'LangChain' },
  ],
  Cloud: [
    { icon: null, label: 'Docker' },
    // { icon: null, label: 'AWS' },
    // { icon: null, label: 'Azure' },
    // { icon: null, label: 'GitHub Actions' },
  ],
  Frontend: [
    { icon: react, label: 'React.js' },
    { icon: html, label: 'HTML5' },
    { icon: css, label: 'CSS3' },
    // { icon: null, label: 'Material UI' },
  ],
};

const tabNames = Object.keys(skillGroups);

export default function SkillsTabs() {
  const [tab, setTab] = React.useState(tabNames[0]);

  return (
    <div className="w-full">
      <div className="flex justify-center mb-8 gap-3 flex-wrap">
        {tabNames.map((name) => (
          <button
            key={name}
            onClick={() => setTab(name)}
            className={`px-4 py-1.5 rounded-full font-medium transition-all text-sm border border-white/10 backdrop-blur-sm ${
              tab === name
                ? 'bg-white/10 text-white'
                : 'text-slate-300 hover:bg-white/5'
            }`}
          >
            {name}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 max-w-3xl mx-auto">
        {skillGroups[tab].map((skill) => (
          <SkillBadge key={skill.label} icon={skill.icon} label={skill.label} />
        ))}
      </div>
    </div>
  );
}
